import config from "../config/config";
import axios from "axios"
import { getToken } from "../Token";
import * as url from "../helpers/url_helper";
import { getTimezoneInfo } from '../helpers/timezone_helper';

const { timezoneName, formattedOffset } = getTimezoneInfo();

const token = getToken();
export const ContactApi = {
    getAllContactList: async (data) => {
        var axiosConfig = {
            method: 'post',
            url: `${config.API_URL}${url.FETCH_ALL_CONTACTUS}`,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                "Timezone-Name": timezoneName,
                "Timezone-Offset": formattedOffset,
            },
            data: data
        };

        return await axios(axiosConfig);
    },

    readContactUs: async (data) => {
        var axiosConfig = {
            method: 'post',
            url: `${config.API_URL}${url.REACT_CONTACT_US}`,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                "Timezone-Name": timezoneName,
                "Timezone-Offset": formattedOffset,
            },
            data: data
        };

        return await axios(axiosConfig);
    },

   getContactById: async (contact_id) => {
    const axiosConfig = {
        method: 'post',  // use POST
        url: `${config.API_URL}${url.FETCH_CONTACT_BY_ID}`,
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            "Timezone-Name": timezoneName,
            "Timezone-Offset": formattedOffset,
        },
        data: { contact_id }  // pass id in the body
    };
    return await axios(axiosConfig);
},

    getAllSalonsWithoutStatus: async (data) => {
        var axiosConfig = {
            method: 'post',
            url: `${config.API_URL}${url.FETCH_ALL_SALONS_WITHOUT_STATUS}?status=${data?.status}`,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                "Timezone-Name": timezoneName,
                "Timezone-Offset": formattedOffset,
            },
            data: data
        };

        return await axios(axiosConfig);
    },
    getSalonById: async (data) => {
        var axiosConfig = {
            method: 'get',
            url: `${config.API_URL}${url.FETCH_SALON}/${data?.salon_id}`,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                "Timezone-Name": timezoneName,
                "Timezone-Offset": formattedOffset,
            },
            data: data
        };

        return await axios(axiosConfig);
    },
    updateSalon: async (data) => {
        var axiosConfig = {
            method: 'post',
            url: `${config.API_URL}${url.UPDATE_SALON}`,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                "Timezone-Name": timezoneName,
                "Timezone-Offset": formattedOffset,
            },
            data: data
        };

        return await axios(axiosConfig);
    },

    updateSalonStatus: async (data) => {
        var axiosConfig = {
            method: 'post',
            url: `${config.API_URL}${url.UPDATE_SALON_STATUS}`,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                "Timezone-Name": timezoneName,
                "Timezone-Offset": formattedOffset,
            },
            data: data
        };
        return await axios(axiosConfig);
    },

    deleteSalon: async (id) => {
        var axiosConfig = {
            method: 'delete',
            url: `${config.API_URL}${url.DELETE_SALON}/${id}`,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                "Timezone-Name": timezoneName,
                "Timezone-Offset": formattedOffset,
            },
           // data: { id }
        };

        return await axios(axiosConfig);
    }
}